/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';
import axios from 'axios';
import { getUserRoleString } from '@/services/utils';
export const useShareDashboardStore = defineStore('shareDashboardStore', {
  state: () => ({
    saving: false,
    alerts: {},
    shareableDashboards: []
  }),
  actions: {
    async listShareableDashboards() {
      try {
        const response = await axios({
          url: `embeddedreporting/owned`
        });
        this.$patch({
          shareableDashboards: response.data
        });
      } catch (error) {
        this.alerts?.error(error.response.data.message);
      }
    },
    async shareDashboard(dashboard) {
      try {
        await axios({
          url: `/embeddedreporting/share`,
          method: 'POST',
          data: dashboard
        });
        this.alerts.success('Dashboard shared successfully!');
      } catch (error) {
        this.alerts?.error(error.response.data.message);
      }
    },
    getUsersFromShareableDashboard(dashboardId) {
      return this.shareableDashboards.find(item => item.id === dashboardId)?.users?.map(user => ({
        ...user,
        label: `${user.name} ${'      ['}  ${getUserRoleString(user)} ${']'}`
      }));
    },
    getShareableDashboardById(dashboardId) {
      return this.shareableDashboards.find(item => item.id === dashboardId);
    },
    getShareableDashboardByUsers(userIds) {
      return this.shareableDashboards.find(item => item.users.filter(user => userIds.includes(user.id)));
    }
  }
});